class FooterAppear {
	constructor() {
		let mm = gsap.matchMedia();

		mm.add('(min-width: 990px)', () => {
			gsap.set('.footer-container', {yPercent: -50});

			const uncover = gsap.timeline({paused: true});

			uncover.to('.footer-container', {yPercent: 0, ease: 'none'});

			ScrollTrigger.create({
				trigger: '.footer-main',
				start: 'top bottom',
				end: 'bottom bottom-=-15%',
				animation: uncover,
				scrub: true,
			});
		});
	}
}
